import {Component, Input, OnInit} from '@angular/core';
import Swal from "sweetalert2";
import {Router} from '@angular/router';
import {BaseWebservice} from '../../../../shared/base/base.webservice';
import { ProcessService } from 'src/app/pages/_services/process.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-summary-status',
    templateUrl: './summary-status.component.html',
    styleUrls: ['./summary-status.component.scss']
})
export class SummaryStatusComponent implements OnInit {
    details: any = {}
    private unsubscribe: Subscription[] = [];
    constructor(private router: Router, private _globalService: BaseWebservice, private processService: ProcessService) {
        this.unsubscribe.push(this._globalService.navigation$.subscribe(value => {
            if(value == 'next') {
                this.navigateToNextPage();
            }
            if(value == 'prev') {
                this.moveBack()

            }
        }))
    }

    moveBack() {
        this.router.navigate([`/aboutyou/${this._globalService.getContentForPage().previousPage}`])

    }
    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
    @Input("isFinish") isFinish = false;
    ngOnInit(): void {
        this.processService.getUserDetails().subscribe(response => {
            if(response['success'] == true) {
                // this.defaultAuth = {
                //     maritalStatus: response['data']['marital']['status']
                // }
                this.details = response['data']
                } else {
                //error
            }
        })


        if(!this._globalService.getProcessStatus("aboutyou") &&!this.isFinish){
            this.processService.setProcessStep({step:"aboutyou"}).subscribe(response => {
                if(response['success'] == true) {
                    // this.defaultAuth = {
                    //     maritalStatus: response['data']['marital']['status']
                    // }
                    // this.details = response['data']
                } else {
                    //error
                }
            })
        }


        this._globalService.setContentData()
    }

    viewChildrenEvent() {
        let childrenListHTML = '<div style="margin-top: 20px;  display: flex !important; flex-direction: column !important;">'
        this.details['children'].forEach(element => {
            childrenListHTML += `<h6 class="" >${element.name} ${ element?.guardian ? ' (' + element?.guardian +')' : ''}</h6>`
        });
        childrenListHTML += '</div>'
        Swal.fire({

            background: "#FFF8EF",
            allowOutsideClick: false,
            customClass: {
                popup: "swal-border",
                htmlContainer: "swal-zero-margin",
                closeButton: "no-border",
                confirmButton: 'swal-close-btton-theme-color'
            },
            showCloseButton: true,
            title: '<strong style="color: white">Children </u></strong>',
            html: childrenListHTML,
//             html: `
//                     <div style="margin-top: 20px;  display: flex !important; flex-direction: column !important;">
//                     <h6 class="h6-color-white" >Aanya Alfaro</h6>
//                     <h6 class="h6-color-white">Musab Lake</h6>
//                     <h6 class="h6-color-white">Huda Denton</h6>
//                     <h6 class="h6-color-white">Gabrielle Mccabe</h6>
//                     <h6 class="h6-color-white">Theresa Sweet</h6>
//                     <h6 class="h6-color-white">Jeremy Fischer</h6>
                  
//                     </div>
// `,
            confirmButtonText: 'Close',
            focusConfirm: false,
            preConfirm: () => {
            }
        }).then((result) => {
        })
    }

    viewPetsEvent() {
        // let pets = ["Stripes"].map(value => {
        //     return `<h6 class="h6-color-white"  >${value}</h6>`
        // }).toString().replace(',',   " ")
        let petsListHTML = '<div style="margin-top: 20px;  display: flex !important; flex-direction: column !important;">'
        this.details['pets'].forEach(element => {
            petsListHTML += `<h6 class="" >${element.name} ${ element?.guardian ? ' (' + element?.guardian +')' : ''}</h6>`
        });
        petsListHTML += '</div>'


        Swal.fire({

            background: "#FFF8EF",
            allowOutsideClick: false,
            customClass: {
                popup: "swal-border",
                htmlContainer: "swal-zero-margin",
                closeButton: "no-border",
                confirmButton: 'swal-close-btton-theme-color',

            },

            showCloseButton: true,

            title: '<strong style="color: white">Pets </u></strong>',
            html: petsListHTML,
            confirmButtonText: 'Close',
            focusConfirm: false,
            preConfirm: () => {
            }
        }).then((result) => {
        })
    }

    editProfile() {
        this.router.navigate([`/aboutyou`])
    }

    navigateToNextPage() {
        this._globalService.appGlobalProgressStatus("aboutyou")

        this.router.navigate([`/`])
    }
}
